export default __webpack_public_path__ + "../img/9adb563e830ec74f9d186ec662577201.png";